import { findFirstValueDefined } from '@dirootie-toolbox/objects';
import { ScreenTemplate } from '@components-fabric/types';

export const getTitle = (obj: ScreenTemplate) =>
  findFirstValueDefined<string>(
    [
      'title',
      'label',
      'route.label',
      'route.breadcrumb',
      'section.title',
      'section.label',
      'section.breadcrumb',
      'id',
    ],
    obj,
    'NOT_SET'
  );
